const Routes = Object.freeze({
  VERIFY_INVITE: '/verify-invite',
  VERIFY_USERS: '/verify-users',
  SUPER_ADMIN_DASHBOARD: '/super-admin',
  SUPER_ADMIN_ORGANIZATIONS: '/super-admin/organizations',
  ORGANIZATIONS: '/organizations',
  REQUESTS: '/requests',
  DASHBOARD: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CONFIRM_EMAIL: '/confirm-email',
  PAYMENT_SELECT: '/payment-select',
  ASSESSMENT: '/assessment',
  ASSESSMENT_STEP: '/assessment/:domainId/step/:step',
  ASSESSMENT_RESULTS: '/assessment-results/:userAssessmentId',
  ASSESSMENT_ANSWERS: '/assessment-answers/:userAssessmentId',
  INPUTS: '/inputs',
  SANDBOX: '/sandbox',
  EMAIL_TEMPLATE: '/email-template',
  REPORTS: '/reports',
  ASSESSMENT_REPORT: '/assessment/:id/report',
  TEMPLATE: '/template',
  ASSESSMENT_DASHBOARD: '/assessment-dashboard/:id',
  TEMPLATES: '/templates',
  TEMPLATE_VIEWER: '/templates/:id',
  RESOURCES: '/resources',
  DOMAIN_RECOMMENDATIONS: '/reports/domain-recommendations/:id',
  SUBDOMAIN_RECOMMENDATIONS: '/reports/subdomain-recommendations/:subdomainId',
  RECOMMENDATIONS: '/reports/recommendations',
  // Company Admin routes
  COMPANY__LOGIN: '/company/login',
  COMPANY__DASHBOARD: '/company',
  COMPANY__ADMINS: '/company/admins',
  // Child user reports
  CHILD_REPORTS: '/child-reports/:userId',
} as const);

export default Routes;

export type AvailableRoutes = (typeof Routes)[keyof typeof Routes];
